import React, { Component } from "react";
import PropTypes from "prop-types";
import { change, formValueSelector } from "redux-form";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import DropdownButton from "react-bootstrap/lib/DropdownButton";
import MenuItem from "react-bootstrap/lib/MenuItem";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import messages from "../../locale/messages";
import {
  removeListPhotos,
  updateListPhotoOrder,
} from "../../actions/manageListPhotos";
import { imageCdnUrl } from "../../config";
import { photosShow } from "../../helpers/photosShow";
import TickIcon from "/public/SiteIcons/correct.svg";
import s from "./PhotosList.css";

import PhotoItem from "./PhotoItem";

class PhotosList extends Component {
  static propTypes = {
    removeListPhotos: PropTypes.func.isRequired,
    listId: PropTypes.number.isRequired,
    listPhotos: PropTypes.array,
    coverPhoto: PropTypes.number,
    change: PropTypes.func.isRequired,
    updateListPhotoOrder: PropTypes.func.isRequired,
  };

  static defaultProps = {
    listPhotos: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      reorderedPhotos: [],
      localCoverPhoto: props.coverPhoto,
    };
  }

  componentDidMount() {
    this.syncWithProps();
  }

  // componentDidUpdate(prevProps) {
  //   if (
  //     prevProps.listPhotos !== this.props.listPhotos ||
  //     prevProps.coverPhoto !== this.props.coverPhoto
  //   ) {
  //     this.syncWithProps();
  //   }
  // }
  componentDidUpdate(prevProps) {
    if (
      prevProps.listPhotos !== this.props.listPhotos ||
      prevProps.coverPhoto !== this.props.coverPhoto
    ) {
      this.syncWithProps();
    }

    // 🔄 Sync coverPhoto to local state
    // if (prevProps.coverPhoto !== this.props.coverPhoto) {
    //   this.setState({ localCoverPhoto: this.props.coverPhoto });
    // }
  }

  // syncWithProps = () => {
  //   const { listPhotos, coverPhoto, change } = this.props;
  //   if (!listPhotos || listPhotos.length === 0) return;

  //   let reordered = [...listPhotos];

  //   if (!coverPhoto) {
  //     const firstPhotoId = reordered[0]?.id;
  //     if (firstPhotoId) {
  //       change("ListPlaceStep2", 'coverPhoto', firstPhotoId);
  //     }
  //   } else {
  //     const coverIndex = reordered.findIndex((photo) => photo.id === coverPhoto);
  //     if (coverIndex > -1) {
  //       const [cover] = reordered.splice(coverIndex, 1);
  //       reordered.unshift(cover);
  //     }
  //   }

  //   this.setState({ reorderedPhotos: reordered });
  // };

  // changeCoverPhoto = (id) => {
  //   const { change } = this.props;
  //   change("ListPlaceStep2", 'coverPhoto', id);
  // };

  syncWithProps = () => {
    const { listPhotos, coverPhoto, change } = this.props;
    if (!listPhotos || listPhotos.length === 0) return;

    let reordered = [...listPhotos];
    let newCover = coverPhoto;

    if (!coverPhoto) {
      newCover = reordered[0]?.id;
      if (newCover) {
        change("ListPlaceStep2", "coverPhoto", newCover);
      }
    } else {
      const coverIndex = reordered.findIndex(
        (photo) => photo.id === coverPhoto
      );
      if (coverIndex > -1) {
        const [cover] = reordered.splice(coverIndex, 1);
        reordered.unshift(cover);
      }
    }

    this.setState({
      reorderedPhotos: reordered,
      localCoverPhoto: newCover,
    });
  };

  changeCoverPhoto = (id) => {
    const { change, updateListPhotoOrder, listId } = this.props;
    const { reorderedPhotos } = this.state;

    const index = reorderedPhotos.findIndex((photo) => photo.id === id);
    if (index === -1) return;

    const updatedPhotos = [...reorderedPhotos];
    const [selectedPhoto] = updatedPhotos.splice(index, 1);
    updatedPhotos.unshift(selectedPhoto);

    console.log(
      "updateListPhotoOrderupdateListPhotoOrder",
      updateListPhotoOrder
    );
    console.log("updatedPhotosupdatedPhotos", updatedPhotos);
    this.setState(
      {
        reorderedPhotos: updatedPhotos,
        localCoverPhoto: id, // ✅ update local immediately
      },
      () => {
        change("ListPlaceStep2", "coverPhoto", id);
        const order = updatedPhotos.map((item, idx) => ({
          id: item.id,
          sort: idx,
        }));
        updateListPhotoOrder(listId, order);
      }
    );
  };

  movePhoto = (dragIndex, hoverIndex) => {
    const { reorderedPhotos } = this.state;
    const updated = [...reorderedPhotos];
    const [dragged] = updated.splice(dragIndex, 1);
    updated.splice(hoverIndex, 0, dragged);
    this.setState({ reorderedPhotos: updated });
  };

  dropPhoto = () => {
    const { reorderedPhotos } = this.state;
    const { updateListPhotoOrder, listId } = this.props;

    const order = reorderedPhotos.map((item, index) => ({
      id: item.id,
      sort: index,
    }));

    updateListPhotoOrder(listId, order);

    if (reorderedPhotos.length && reorderedPhotos[0]) {
      this.changeCoverPhoto(reorderedPhotos[0].id);
    }
  };

  // handleDelete = (deletedItem) => {
  //   const { removeListPhotos } = this.props;
  //   const { reorderedPhotos } = this.state;

  //   const updatedPhotos = reorderedPhotos.filter(photo => photo.id !== deletedItem.id);

  //   this.setState({ reorderedPhotos: updatedPhotos }, () => {
  //     if (this.props.coverPhoto === deletedItem.id && updatedPhotos.length > 0) {
  //       this.changeCoverPhoto(updatedPhotos[0].id);
  //     }
  //   });

  //   removeListPhotos(deletedItem.listId, deletedItem.name, true);
  // };

  handleDelete = (deletedItem) => {
    const { removeListPhotos, change, updateListPhotoOrder, listId } =
      this.props;
    const { reorderedPhotos, localCoverPhoto } = this.state;

    // Remove deleted photo
    const updatedPhotos = reorderedPhotos.filter(
      (photo) => photo.id !== deletedItem.id
    );

    // Update state
    let newCoverPhoto = localCoverPhoto;
    if (localCoverPhoto === deletedItem.id && updatedPhotos.length > 0) {
      newCoverPhoto = updatedPhotos[0].id;
    }

    this.setState(
      {
        reorderedPhotos: updatedPhotos,
        localCoverPhoto: newCoverPhoto,
      },
      () => {
        // ✅ Update form cover photo field
        change("ListPlaceStep2", "coverPhoto", newCoverPhoto);

        // ✅ Sync order with backend
        const order = updatedPhotos.map((photo, index) => ({
          id: photo.id,
          sort: index,
        }));
        updateListPhotoOrder(listId, order);
      }
    );

    // ✅ Delete photo from backend
    removeListPhotos(deletedItem.listId, deletedItem.name, true);
  };

  render() {
    const { coverPhoto } = this.props;
    const { reorderedPhotos } = this.state;
    const path = photosShow(`${imageCdnUrl}upload/`);

    return (
      <DndProvider backend={HTML5Backend}>
        <div className={s.displayGrid} ref={(ref) => (this.gridRef = ref)}>
          {reorderedPhotos.map((item, index) => (
            <PhotoItem
              key={item.id}
              index={index}
              item={item}
              path={path}
              movePhoto={this.movePhoto}
              dropPhoto={this.dropPhoto}
              isCover={index === 0}
              onChangeCover={() => this.changeCoverPhoto(item.id)}
              onDelete={() => this.handleDelete(item)}
              scrollContainer={this.gridRef}
            />
          ))}
        </div>
      </DndProvider>
    );
  }
}

const selector = formValueSelector("ListPlaceStep2");

const mapState = (state) => ({
  listPhotos: state?.location?.listPhotos,
  coverPhoto: selector(state, "coverPhoto"),
});

const mapDispatch = {
  removeListPhotos,
  change,
  updateListPhotoOrder,
};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(PhotosList))
);
